import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export function getAvatarDescription(avatar: { name: string; age: number; gender: string; occupation: string; personality: string }): string {
  return `${avatar.name} - ${avatar.age}歳 ${avatar.gender}, ${avatar.occupation}, ${avatar.personality}`;
}
